'use client';

import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { MapPin, Mail, Clock, MessageCircle } from 'lucide-react';

const WA_NUMBER = '6287786556067';
const WA_DISPLAY = '+62 877-8655-6067';

const socialLinks = [
  {
    name: 'WhatsApp',
    handle: WA_DISPLAY,
    href: `https://wa.me/${WA_NUMBER}`,
    color: 'bg-green-500/10 border-green-500/20 text-green-600 hover:bg-green-500/20',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
  },
  {
    name: 'Facebook',
    handle: '@NayveraIndoTransport',
    href: 'https://facebook.com/NayveraIndoTransport',
    color: 'bg-blue-600/10 border-blue-600/20 text-blue-600 hover:bg-blue-600/20',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    handle: '@nayvera.indotransport',
    href: 'https://instagram.com/nayvera.indotransport',
    color: 'bg-pink-500/10 border-pink-500/20 text-pink-600 hover:bg-pink-500/20',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
  },
  {
    name: 'TikTok',
    handle: '@nayvera.indotransport',
    href: 'https://tiktok.com/@nayvera.indotransport',
    color: 'bg-gray-900/10 border-gray-900/20 text-gray-800 hover:bg-gray-900/20',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
      </svg>
    ),
  },
];

const operatingHours = [
  { day: 'Senin – Jumat', hours: '07.00 – 21.00 WIB' },
  { day: 'Sabtu', hours: '07.00 – 20.00 WIB' },
  { day: 'Minggu & Hari Libur', hours: '08.00 – 18.00 WIB' },
  { day: 'Booking & WhatsApp', hours: '24 Jam / 7 Hari' },
];

export default function KontakPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-28 pb-16 bg-primary overflow-hidden">
        <div className="absolute inset-0 bg-hero-pattern" />
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 left-10 w-64 h-64 rounded-full border border-accent/30" />
          <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full border border-accent/20" />
        </div>
        <div className="relative max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 text-center">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
            <span className="text-accent text-xs font-bold uppercase tracking-widest">Hubungi Kami</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-4 leading-tight">
            Kami Siap Melayani<br />
            <span className="text-gradient-gold">Setiap Saat</span>
          </h1>
          <p className="text-white/70 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Hubungi kami melalui WhatsApp, media sosial, atau kunjungi kantor kami langsung. Tim kami siap membantu kebutuhan transportasi Anda.
          </p>
        </div>
      </section>

      {/* Contact Info + Social */}
      <section className="py-16 lg:py-20">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

            {/* Contact Details */}
            <div className="lg:col-span-1 space-y-5">
              <div>
                <div className="section-divider mb-4" />
                <h2 className="text-xl font-extrabold text-foreground mb-1">Informasi Kontak</h2>
                <p className="text-muted-foreground text-sm">Jangan ragu untuk menghubungi kami kapan saja.</p>
              </div>

              {/* WhatsApp */}
              <a
                href={`https://wa.me/${WA_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-4 p-4 bg-green-50 border border-green-200 rounded-xl hover:bg-green-100 transition-colors group"
              >
                <div className="w-11 h-11 rounded-xl bg-green-500 text-white flex items-center justify-center shrink-0">
                  <MessageCircle size={20} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-green-700 mb-0.5">WhatsApp</div>
                  <div className="font-bold text-foreground group-hover:text-green-700 transition-colors">{WA_DISPLAY}</div>
                  <div className="text-xs text-muted-foreground mt-0.5">Klik untuk chat langsung</div>
                </div>
              </a>

              {/* Address */}
              <div className="flex items-start gap-4 p-4 bg-white border border-border rounded-xl">
                <div className="w-11 h-11 rounded-xl bg-primary/8 text-primary flex items-center justify-center shrink-0">
                  <MapPin size={20} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-0.5">Alamat Kantor</div>
                  <div className="font-semibold text-foreground text-sm leading-relaxed">
                    Jl. Atang Sanjaya No.Rt 01,<br />
                    RT.002/RW.005, Benda,<br />
                    Kec. Benda, Kota Tangerang,<br />
                    Banten 15125
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4 p-4 bg-white border border-border rounded-xl">
                <div className="w-11 h-11 rounded-xl bg-primary/8 text-primary flex items-center justify-center shrink-0">
                  <Mail size={20} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-0.5">Email</div>
                  <a href="mailto:info@nayveraindotransport.com" className="font-semibold text-foreground hover:text-accent transition-colors text-sm">
                    info@nayveraindotransport.com
                  </a>
                  <div className="text-xs text-muted-foreground mt-0.5">[Dapat diperbarui admin]</div>
                </div>
              </div>
            </div>

            {/* Social Media + Operating Hours */}
            <div className="lg:col-span-2 space-y-8">

              {/* Social Media */}
              <div>
                <h2 className="text-xl font-extrabold text-foreground mb-1">Media Sosial</h2>
                <p className="text-muted-foreground text-sm mb-5">Ikuti kami untuk info terbaru, promo, dan armada terkini.</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {socialLinks?.map((social) => (
                    <a
                      key={`social-${social?.name}`}
                      href={social?.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`flex items-center gap-4 p-4 rounded-xl border transition-all duration-200 ${social?.color}`}
                    >
                      <div className="w-11 h-11 rounded-xl bg-white/60 flex items-center justify-center shrink-0 shadow-sm">
                        {social?.icon}
                      </div>
                      <div>
                        <div className="font-bold text-sm">{social?.name}</div>
                        <div className="text-xs opacity-75 mt-0.5">{social?.handle}</div>
                      </div>
                    </a>
                  ))}
                </div>
                <p className="text-xs text-muted-foreground mt-3 italic">
                  * Handle media sosial dapat diperbarui melalui dashboard admin.
                </p>
              </div>

              {/* Operating Hours */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-xl bg-accent/15 text-accent flex items-center justify-center">
                    <Clock size={20} />
                  </div>
                  <div>
                    <h2 className="text-xl font-extrabold text-foreground">Jam Operasional</h2>
                    <p className="text-muted-foreground text-xs">Waktu layanan kantor & customer service</p>
                  </div>
                </div>
                <div className="bg-white border border-border rounded-xl overflow-hidden">
                  {operatingHours?.map((item, i) => (
                    <div
                      key={`hours-${i}`}
                      className={`flex items-center justify-between px-5 py-3.5 ${
                        i < operatingHours?.length - 1 ? 'border-b border-border' : ''
                      } ${i === operatingHours?.length - 1 ? 'bg-accent/5' : ''}`}
                    >
                      <span className={`text-sm font-medium ${i === operatingHours?.length - 1 ? 'text-accent font-bold' : 'text-foreground'}`}>
                        {item?.day}
                      </span>
                      <span className={`text-sm font-semibold ${i === operatingHours?.length - 1 ? 'text-accent' : 'text-muted-foreground'}`}>
                        {item?.hours}
                      </span>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-muted-foreground mt-2 italic">
                  * Jam operasional dapat diperbarui melalui dashboard admin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA WhatsApp */}
      <section className="py-10 bg-muted border-y border-border">
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
            <div>
              <h3 className="text-xl font-extrabold text-foreground">Butuh Bantuan Segera?</h3>
              <p className="text-muted-foreground text-sm mt-1">Tim kami siap membantu Anda 24 jam via WhatsApp.</p>
            </div>
            <a
              href={`https://wa.me/${WA_NUMBER}?text=Halo%20NAYVERA%20INDO%20TRANSPORT%2C%20saya%20ingin%20bertanya%20tentang%20layanan%20rental%20kendaraan.`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2.5 bg-green-500 hover:bg-green-600 text-white font-bold px-7 py-3.5 rounded-xl transition-colors shadow-lg whitespace-nowrap"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              HUBUNGI KAMI VIA WHATSAPP
            </a>
          </div>
        </div>
      </section>

      {/* Google Maps */}
      <section className="py-0">
        <div className="w-full">
          <div className="bg-primary px-4 sm:px-6 lg:px-8 xl:px-10 py-5 max-w-screen-2xl mx-auto flex items-center gap-3">
            <MapPin size={20} className="text-accent shrink-0" />
            <div>
              <div className="text-white font-bold text-sm">Lokasi Kantor Kami</div>
              <div className="text-white/60 text-xs">Sewa Mobil - PT Merah Putih Globalindo · Jl. Atang Sanjaya No.Rt 01, RT.002/RW.005, Benda, Kec. Benda, Kota Tangerang, Banten 15125</div>
            </div>
            <a
              href="https://maps.app.goo.gl/GvqieLszz3yjmWiX8"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-auto btn-primary px-4 py-2 rounded-lg text-xs font-bold whitespace-nowrap shrink-0"
            >
              Buka di Maps
            </a>
          </div>
          <div className="w-full h-[420px] sm:h-[500px]">
            <iframe
              src="https://maps.google.com/maps?q=Jl.+Atang+Sanjaya+No.Rt+01,+RT.002/RW.005,+Benda,+Kec.+Benda,+Kota+Tangerang,+Banten+15125&output=embed&z=16"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokasi NAYVERA INDO TRANSPORT"
            />
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
